import React from "react";
import {Grid } from '@material-ui/core';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';



const NestlingRadioType = ({ value, onChange, itemName, styleToggle }) => {

  return (
    <>
    <Grid container direction="row" justifyContent="space-around" alignItems="center" >
      <Grid item xs={6}>
        <ToggleButtonGroup
          color="error"
          size="small"
          value={value}
          exclusive
          onChange={onChange}
          style={styleToggle}
        >
          <ToggleButton value="url" color="info" >URL</ToggleButton>
          <ToggleButton value="upload" color="info">Upload</ToggleButton>
        </ToggleButtonGroup>
      </Grid>
      <Grid item xs={6}>
            {itemName}
      </Grid>
    </Grid>
    </>
  );
};

export default NestlingRadioType;
